import { ItemUnit, OrderItemState } from '@backend/domain'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { ArrayMinSize, IsArray, IsEnum, IsNotEmpty, IsOptional, IsPositive, IsUUID } from 'class-validator'

export class OrderItemResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	id: string

	@ApiProperty({ type: String })
	name: string

	@ApiProperty({ type: Number })
	quantity: number

	@ApiProperty({ enum: ItemUnit })
	quantityUnit: ItemUnit

	@ApiProperty({ type: Number })
	unitPrice: number

	@ApiProperty({ type: Number })
	paidQuantity: number

	@ApiProperty({ type: Boolean })
	paid: boolean

	@ApiProperty({ enum: OrderItemState })
	state: OrderItemState

	@ApiPropertyOptional({ type: Number })
	course?: number

	@ApiProperty({ type: String, format: 'uuid' })
	menuItemId: string
}

export class CreateOrderItemRequest {
	@ApiProperty({ type: String, format: 'uuid' })
	@IsNotEmpty()
	@IsUUID()
	menuItemId: string

	@ApiProperty({ type: Number, minimum: 1 })
	@IsNotEmpty()
	@IsPositive()
	quantity: number
}

export class PayOrderItemRequest {
	@ApiProperty({ type: String, format: 'uuid' })
	@IsNotEmpty()
	@IsUUID()
	id: string

	@ApiProperty({ type: Number, minimum: 1 })
	@IsNotEmpty()
	@IsPositive()
	quantity: number
}

export class CustomerOrderItemRequest extends CreateOrderItemRequest {
	@ApiPropertyOptional({ type: Boolean })
	@IsOptional()
	paid?: boolean
}

export class UpdateItemsStateRequest {
	@ApiProperty({ type: String, format: 'uuid', isArray: true })
	@IsNotEmpty()
	@IsArray()
	@ArrayMinSize(1)
	itemIds: string[]

	@ApiProperty({ enum: OrderItemState })
	@IsNotEmpty()
	@IsEnum(OrderItemState)
	state: OrderItemState
}
